import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGNS_COUNTS } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignsCount() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchData = async () => {
    isLoading.value = true;

    try {
      const response = await Req.get(
        CATEGORY_COMMISSION_CAMPAIGNS_COUNTS,
        null,
        {
          baseURL: '/sellerofficeapi/rest',
          headers: { Accept: 'application/json' },
        },
      );

      if (!response.status || response.status !== 200) {
        throw new Error('Network response was not OK');
      }

      data.value = response.data;
      error.value = null;
    } catch (err) {
      error.value = err || null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchData,
  };
}
